import { ToastContainer, toast as reactToast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import 'react-toastify/dist/ReactToastify.css';

const Toaster = () => {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <ToastContainer
      position={isRTL ? 'top-left' : 'top-right'}
      autoClose={5000}
      closeOnClick
      rtl={isRTL}
      draggable
      theme="colored"
      style={{ fontFamily: "'Cairo', sans-serif" }}
      stacked
    />
  );
};

// Re-export toast directly but wrap error/success to enforce styles if needed
// Actually react-toastify's toast object is complex, better to just export it directly
// and handle styling via the container config above.
const toast = reactToast;

export { Toaster, toast };
